export const howWeCompareAgentsPath = '/how-we-compare-agents';
